module.exports = __webpack_public_path__ + "static/img/znzg.333c445.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/znzg.png
// module id = Pi9G
// module chunks = 3